// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V2i$Linear from "./V2i.res.js";
import * as Rect$Linear from "./Rect.res.js";

let zero = {
  pos: V2i$Linear.zero,
  size: V2i$Linear.zero
};

function fromSize(size) {
  return {
    pos: [
      0,
      0
    ],
    size: size
  };
}

function boundingBoxFromPoints(points) {
  let xs = points.map(prim => prim[0]);
  let ys = points.map(prim => prim[1]);
  let min_0 = Math.min(...xs);
  let min_1 = Math.min(...ys);
  let min = [
    min_0,
    min_1
  ];
  let max_0 = Math.max(...xs);
  let max_1 = Math.max(...ys);
  let max = [
    max_0,
    max_1
  ];
  return {
    pos: min,
    size: V2i$Linear.minus(max, min)
  };
}

function bounds(param) {
  let pos = param.pos;
  return [
    pos,
    V2i$Linear.plus(pos, param.size)
  ];
}

function rotate90(param) {
  let match = param.size;
  let h = match[1];
  let match$1 = param.pos;
  return {
    pos: [
      -1 * (match$1[1] + h | 0) | 0,
      -1 * match$1[0] | 0
    ],
    size: [
      h,
      match[0]
    ]
  };
}

function rotate180(param) {
  let match = param.size;
  let h = match[1];
  let w = match[0];
  let match$1 = param.pos;
  return {
    pos: [
      -1 * (match$1[0] + w | 0) | 0,
      -1 * (match$1[1] + h | 0) | 0
    ],
    size: [
      w,
      h
    ]
  };
}

function rotate270(param) {
  let match = param.size;
  let w = match[0];
  let match$1 = param.pos;
  return {
    pos: [
      match$1[1],
      match$1[0] - w | 0
    ],
    size: [
      match[1],
      w
    ]
  };
}

let jsonCodec = Rect$Linear.jsonCodec(Jzon.int);

export {
  zero,
  fromSize,
  boundingBoxFromPoints,
  bounds,
  rotate90,
  rotate180,
  rotate270,
  jsonCodec,
}
/* jsonCodec Not a pure module */
